import { Power3, gsap } from "gsap";
import { ISymbolAnimationConf, ReelBaseSymbol } from "../../../core/reel/symbol/ReelBaseSymbol";
import { SanSymbolData } from './SanSymbolData';
import { SanSpriteSymbol, SanSymState } from "./SanSpriteSymbol";
import { SanWinSymbol } from "./SanWinSymbol";
import { Helper } from "../../../core/utils/Helper";
import { SymbolMultiplyCounter } from "../../modules/symbol/SymbolMultiplyCounter";
import { ArrayHelper } from "../../../core/utils/ArrayHelper";

export class SanRevealerSymbol extends SanSpriteSymbol {

    public get symbolHeight(): number {
        return SanSymbolData.fetchSymHeightSize(this.sizeType.value);
    }

    private winSymbol:SanWinSymbol;

    constructor(ID: number,symName:string, state: string = SanSymState.NORMAL, typeSize:any = 2) {
        super(ID, symName, state, typeSize);
        this.extraInit();
    }

    protected extraInit():void{
        this.sortChildren();
    }

    public isSpecial(value: number, durr?: number): void {
        if(!this.multies){
            this.multies = this.addChild(new SymbolMultiplyCounter());
            this.multies.addValue(value, durr);
            this.multies.position.x = this.symbolWidth/(value >= 10 ? 4 : 3.25);
            this.multies.position.y = this.symbolHeight/(this.sizeType.value == 4 ? 3 : 4);
            this.multies.zIndex = 3000;
            this.sortableChildren = true;
        }else{
            this.multies.addValue(value,durr);
        }
    }

    playWin(hits: boolean, duration: number, winLvl: number = 0) {
        this.markNonWin(!hits, 0.5, duration/4);

        if (hits) {
            if (this.useWinSymbol()) {
                this.winSymbol.Play(winLvl, duration);
                const tl = this.winSymbol.tlWin;
                return tl;
            }
        }
    }

    public playBigWin(duration: number, lvl: number): void {
        if(this.useWinSymbol()){
            this.winSymbol.BigWinStart(duration);
        }
    }

    public stopBigWin(duration: number): void {
        if(this.useWinSymbol()){
            this.winSymbol.BigWinStop(duration);
        }
    }

    public useWinSymbol(shouldBeCreated: boolean = true): boolean {
    
        if (!this.winSymbol && this._mainSprite && shouldBeCreated) {
            const newWinSymbol = new SanWinSymbol(this.posID[0], this.symName, "normal", this.sizeType.value);
            this.winSymbols.push(newWinSymbol);
            this.winSymbol = newWinSymbol;
            this.winSymbol.position = Helper.copyLocalPosition(this.winSymbol, this._mainSprite);
        }
        else if(this.winSymbol && this.winSymbol.symName != this.symName){
            this.winSymbol.setSymbol(this.symName);
        }

        if(this.winSymbol){
            this.winSymbol.position = Helper.copyLocalPosition(this.winSymbol, this._mainSprite);
            if(this.multies && this.multies.visible)
                this.winSymbol.isSpecial(this.multies.curAmm);
        }

        return !!this.winSymbol;
    }

    public setSymbol(symName: string): void {
        super.setSymbol(symName);
        if(this.multies) this.multies.visible = false;
    }

    public changeState(stateConfig: ISymbolAnimationConf): gsap.core.Timeline {
        if(!stateConfig.sizeType) stateConfig.sizeType = this.sizeType.value;
        if (!stateConfig.forceState && this.state.value === stateConfig.state && this.sizeType.value === stateConfig.sizeType)
            return this._timeLine ? this._timeLine : gsap.timeline();
        else
            return this.AnimateState(stateConfig);
    }

    public cleanUp(): void {

        if(this.winSymbol){
            this.winSymbol.remove();
            this.winSymbol = null!;
            this.winSymbols = [];
        }
        if(this.multies){
            this.multies.visible = false;
        }
    }

    public onResize(): void {
        if (this.winSymbol) {
            this.winSymbol.position = Helper.copyLocalPosition(this.winSymbol, this._mainSprite);
        }
    }

    public remove(): void {
        this.cleanUp();
        super.remove();
    }
}
